// Above-the-fold defaults so the hero never flashes empty while /api/content loads.
// The admin panel is the source of truth; these are only the initial paint values.
export const DEFAULT_CONTENT = {
  home: {
    studioLead: {
      en: "We mill wood into surfaces that hold light. Parametric relief, acoustic depth, and a tolerance of half a millimetre.",
      fi: "Jyrsimme puusta pintoja, jotka kantavat valoa. Parametrinen reliefi, akustinen syvyys ja puolen millimetrin toleranssi.",
    },
    ctaTitle: { en: "Modular surfaces,\nmade to match", fi: "Modulaariset pinnat,\njotka sopivat yhteen" },
    ctaText: { en: "", fi: "" },
    quote: {
      en: "Where the spirit does not work with the hand, there is no art.",
      fi: "Missä henki ei työskentele käden kanssa, siellä ei ole taidetta.",
    },
    quoteAuthor: "Leonardo da Vinci",
    slides: [
      {
        id: "kaari",
        no: "01",
        title: "KAARI",
        image: "/match/kaari.jpg",
        kicker: { en: "[ 01 // ARCHITECTURAL / LINEAR ]", fi: "[ 01 // ARKKITEHTONINEN / LINEAARINEN ]" },
        text: { en: "", fi: "" },
      },
      { id: "havu", no: "02", title: "HAVU", image: "/match/havu.jpg", kicker: { en: "", fi: "" }, text: { en: "", fi: "" } },
      { id: "virta", no: "03", title: "VIRTA", image: "/match/virta.jpg", kicker: { en: "", fi: "" }, text: { en: "", fi: "" } },
      { id: "keha", no: "04", title: "KEHÄ", image: "/match/keha.jpg", kicker: { en: "", fi: "" }, text: { en: "", fi: "" } },
    ],
  },
  services: { items: [] },
  menu: {
    items: [
      { label: { en: "Home", fi: "Etusivu", tr: "Anasayfa", es: "Inicio" }, path: "/", visible: true, auto: "" },
      {
        label: { en: "Products", fi: "Tuotteet", tr: "Ürünler", es: "Productos" },
        path: "/products",
        visible: true,
        auto: "collections",
      },
      { label: { en: "Services", fi: "Palvelut", tr: "Hizmetler", es: "Servicios" }, path: "/services", visible: true, auto: "" },
      { label: { en: "Portfolio", fi: "Portfolio", tr: "Portföy", es: "Portafolio" }, path: "/portfolio", visible: true, auto: "" },
      { label: { en: "About us", fi: "Tietoa meistä", tr: "Hakkımızda", es: "Sobre nosotros" }, path: "/about", visible: true, auto: "" },
      { label: { en: "Contact", fi: "Ota yhteyttä", tr: "İletişim", es: "Contacto" }, path: "/contact", visible: true, auto: "" },
    ],
    ctaLabel: { en: "Request a quote", fi: "Pyydä tarjous", tr: "Teklif alın", es: "Solicitar presupuesto" },
  },
  slider: {
    title: { en: "", fi: "", tr: "", es: "" },
    speed: 34,
    placements: [
      { page: "home", anchor: "bottom", visible: true },
      { page: "about", anchor: "bottom", visible: true },
    ],
  },
  about: { philosophy: { en: "", fi: "" }, paragraphs: [], stats: [], team: [], process: [], studioImage: "" },
  clients: { items: [] },
  contact: { hours: { en: "", fi: "" }, offices: [] },
};
